// extracted by mini-css-extract-plugin
export default {"noBetSlipWrp":"betSlip_noBetSlipWrp__-fexO","text2":"betSlip_text2__se7Fo"};